"use client";

import { Link } from "@/i18n/routing";
import { useEffect } from "react";
import { useTranslations, useLocale } from "next-intl";

export default function ErrorBoundary({
    error,
}: {
    error: Error & { digest?: string };
}) {
    const t = useTranslations();
    const locale = useLocale() as "ar" | "en";

    useEffect(() => {
        console.error("Route segment error:", error);
        try {
            const body = JSON.stringify({
                kind: "segment-error",
                message: error?.message ?? "",
                stack: error?.stack ?? null,
                digest: error?.digest ?? null,
                url: typeof window !== "undefined" ? window.location.href : "",
            });
            if (typeof navigator !== "undefined" && navigator.sendBeacon) {
                navigator.sendBeacon(
                    "/api/client-error",
                    new Blob([body], { type: "application/json" }),
                );
            }
        } catch {
            // ignore
        }
    }, [error]);

    return (
        <main className="min-h-[calc(100vh-150px)] flex items-center justify-center px-4 md:px-10 lg:px-14 py-10">
            <div className="mx-auto max-w-2xl text-center space-y-4">
                <h1 className="text-2xl md:text-3xl font-semibold">
                    {t("common.error")}
                </h1>
                <p className="text-muted-foreground">
                    {t("errors.serverError")}
                </p>
                <div className="pt-2">
                    <Link
                        href="/"
                        locale={locale}
                        className="inline-flex items-center justify-center rounded-md bg-primary px-5 py-2.5 text-primary-foreground font-medium"
                    >
                        {t("errors.backToHome")}
                    </Link>
                </div>
            </div>
        </main>
    );
}

